export type MatrixMutationErrorEntry = {
  title: string;
  error: unknown;
  fallback: string;
};

// The first failing mutation in priority order, so the page shows one alert.
export function pickFirstMatrixError(
  entries: readonly MatrixMutationErrorEntry[],
): MatrixMutationErrorEntry | null {
  return entries.find((entry) => entry.error != null) ?? null;
}
